import styled from 'styled-components'
import { COLOURS } from 'resources'

const RegionText = styled.div`
  font-size: 10px;
  margin-top: 10px;
  color: ${COLOURS.darkGrey};
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 0 10px 10px 0;
`

export default RegionText
